if (
  process.env.NODE_ENV === 'production' &&
  'serviceWorker' in navigator &&
  'caches' in window
) {
  const appServiceWorkerPath = new URL(
    `${process.env.BASE_URL}service-worker.js`,
    window.location.origin
  ).pathname
  const migrationKey = 'students-frontend-clear-legacy-cache'

  Promise.all([
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      const appRegistrations = registrations.filter((registration) => {
        const workers = [
          registration.active,
          registration.waiting,
          registration.installing,
        ]
        return workers.some(
          (worker) =>
            worker &&
            new URL(worker.scriptURL).pathname === appServiceWorkerPath
        )
      })

      return Promise.all(
        appRegistrations.map((registration) => registration.unregister())
      ).then((results) => results.some(Boolean))
    }),
    caches.keys().then((cacheNames) =>
      Promise.all(
        cacheNames
          .filter((name) => name.startsWith('students_frontend-precache'))
          .map((name) => caches.delete(name))
      ).then((results) => results.some(Boolean))
    ),
  ])
    .then(([workerRemoved, cacheRemoved]) => {
      const cacheWasCleared = workerRemoved || cacheRemoved
      if (cacheWasCleared && sessionStorage.getItem(migrationKey) !== 'done') {
        sessionStorage.setItem(migrationKey, 'done')
        window.location.reload()
      } else if (!cacheWasCleared) {
        sessionStorage.removeItem(migrationKey)
      }
    })
    .catch((error) => {
      console.error('Failed to remove the legacy app service worker:', error)
    })
}
